import { bankDetailConstants } from "../../constants";
import { bankDetailService } from "../../services";
import { alertActions } from "../alert.actions";

export const bankDetailActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    bankDetailService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: bankDetailConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: bankDetailConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: bankDetailConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    bankDetailService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: bankDetailConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: bankDetailConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: bankDetailConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    bankDetailService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: bankDetailConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: bankDetailConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: bankDetailConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    bankDetailService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: bankDetailConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: bankDetailConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: bankDetailConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: bankDetailConstants.CLEAR };
}
